import { ecsApi } from '@services';
import {
    GetFormationCategoriesResponse,
    GetFormationQuestionsPayload,
    GetFormationQuestionsResponse,
    GetFormationsPayload,
    GetFormationsResponse,
    PostFormationResultsPayload
} from './formations.types';

export const formationsApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getFormationThematics: builder.mutation<GetFormationCategoriesResponse, undefined>({
            query: () => ({
                url: '/formations/thematics',
                method: 'GET'
            })
        }),
        getFormations: builder.mutation<GetFormationsResponse, GetFormationsPayload>({
            query: ({ categoryId }) => ({
                url: `/formations/${categoryId}`,
                method: 'GET'
            })
        }),
        getFormationQuestions: builder.mutation<GetFormationQuestionsResponse, GetFormationQuestionsPayload>({
            query: ({ formationId }) => ({
                url: `/formations/${formationId}/questions`,
                method: 'GET'
            })
        }),
        postFormationResults: builder.mutation<undefined, PostFormationResultsPayload>({
            query: ({ formationId, ...payload }) => ({
                url: `/formations/${formationId}/answers`,
                method: 'POST',
                body: payload
            })
        })
    })
});

export const {
    useGetFormationsMutation,
    useGetFormationQuestionsMutation,
    useGetFormationThematicsMutation,
    usePostFormationResultsMutation
} = formationsApi;
